import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import { getConfig } from "../../utils/config";

const config = getConfig();

const colors = config.theme.colors;

const getColor = (color) => {
  if (colors[color]) {
    return colors[color];
  }
  return colors.primary;
};

const Botao = styled.button`
  font-family: ${config.theme.font.family}, sans-serif;
  padding: ${config.theme.button.padding};
  border-radius: ${config.theme.button.borderRadius};
  color: ${config.theme.button.color};
  letter-spacing: ${config.theme.button.letterSpacing};
  font-weight: bold;
  box-shadow: none;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  transition: all 0.2s;

  ${(props) => {
    if (props.color) {
      return css`
        background-color: ${getColor(props.color)};
      `;
    } else {
      return css`
        background-color: ${config.theme.button.background};
      `;
    }
  }}

  &:active {
    background-color: ${config.theme.button.hoverBackground};
    color: ${config.theme.button.hoverColor};
  }

  cursor: pointer;

  border: none;

  ${(props) => {
    if (props.textUpperCase) {
      return css`
        text-transform: uppercase;
      `;
    }
  }}

  ${(props) => {
    if (props.disabled) {
      return css`
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
        background-color: ${config.theme.button.background} !important;
        color: ${config.theme.button.color} !important;
      `;
    }
  }}


  ${(props) => {
    if (props.bigButton) {
      return css`
        font-size: 1.1em;
        padding: 10px 15px;
        border-radius: 25px;
        border-bottom: 7px solid
          color-mix(in srgb, ${getColor(props.color)} 80%, transparent);

        &:active {
          border-bottom: 1px solid
            color-mix(in srgb, ${getColor(props.color)} 80%, transparent);
        }

        ${props.disabled ? "border-bottom: 0px;" : ""}
      `;
    }
  }}


  ${(props) => {
    if(props.as === "text") {
      return css`
        background-color: transparent !important;
        padding: 0px !important;
        padding-left: 2px !important;
        padding-right: 3px !important;
        padding-bottom: 1px !important;

        cursor: pointer;

        color: ${getColor(props.color) || colors.primary};
      `;
    }
  }}
`;

const _Button = styled.button`
  border: none;
  font-family: Titillium Web;
  cursor: pointer;
  border-radius: 2px;
  background-color: ${colors.darkBlue};
  color: white;
  padding-top: 8px;
  padding-bottom: 7px;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: 900;

  :hover {
    background-color: ${colors.lightBlue};
    border-radius: 4px;
    transition: all 0.2s;
  }
  :disabled {
    background-color: #bdced5;
    color: #f1f3f4;
    cursor: not-allowed;
  }
  :active {
    background-color: #0572b5;
    color: #3bbdff;
  }

  ${(props) => {
    if (props.outline) {
      return css`
        background-color: transparent !important;
        border-size: 3px;
        color: ${colors.darkBlue};
        border: 2px solid ${colors.darkBlue};
        :hover {
          color: ${colors.lightBlue};
          border: 2px solid ${colors.lightBlue};
          backbackground-color: transparent !important;
        }
        :disabled {
          color: ${colors.lightCyan};
          border: 2px solid ${colors.lightCyan};
          backbackground-color: transparent !important;
        }
        :active {
          backbackground-color: transparent !important;
          border: 2px solid #0572b5;
          color: #0572b5;
        }
      `;
    }
    if (props.text) {
      return css`
        background-color: transparent !important;
        padding: 0px !important;
        padding-left: 2px !important;
        padding-right: 3px !important;
        padding-bottom: 1px !important;

        border-size: 3px;
        color: ${colors.darkBlue};
        border-bottom: 2px solid ${colors.darkBlue};
        :hover {
          color: ${colors.lightBlue};
          border-bottom: 2px solid ${colors.lightBlue};
          background-color: #ebebeb;
        }
        :disabled {
          color: ${colors.lightCyan};
          border-bottom: 2px solid ${colors.lightCyan};
          background-color: #ebebeb;
        }
        :active {
          background-color: #ebebeb;
          border-bottom: 2px solid #0572b5;
          color: #0572b5;
        }
      `;
    }
  }}
`;

const TextButton = styled.div`
  color: ${colors.darkBlue};
  cursor: pointer;
  font-weight: bold;
  ${(props) => {
    if (props.disabled) {
      return css`
        opacity: 0.5;
        cursor: not-allowed;
      `;
    }
  }}
`;
/**
 * Default Easygesto Button
 */

const Button__ = (props) => {
  function onClick() {
    if (props.disabled) {
      return;
    }
    props.onClick();
  }

  if (props.as) {
    if (props.as === "text") {
      return (
        <TextButton
          className={`${props.loading ? "px-3" : ""}`}
          {...props}
          onClick={onClick}
        >
          {props.children}
        </TextButton>
      );
    }
  } else if (props.icon != undefined) {
    return (
      <TextButton {...props} onClick={onClick}>
        {" "}
        <i className={`${props.icon}`} />
      </TextButton>
    );
  } else {
    return (
      <_Button className={`${props.loading ? "px-3" : ""}`} {...props}>
        {props.children}
      </_Button>
    );
  }
};


const Button = (props) => {
  return (
    <Botao {...props}>
      {props.loading ? <i className="fa fa-spinner fa-spin mr-2" /> : ""}
      {props.label || props.children}
      {props.rightIcon && <i className={`fa ${props.rightIcon} ml-2`} />}
    </Botao>
  );
};

Button.PropTypes = {
  /**
   *  Styles genreal
   */
  as: PropTypes.string,
  /**
   *  Icons from fontawesome
   */
  icon: PropTypes.string,
  /**
   *  Child nodes
   */
  children: PropTypes.node,
};

export default Button;



// WEBPACK FOOTER //
// ./src/_components/Button/index.jsx